interface IProps {
	icon: React.ReactNode;
	className?: string;
}

export const Icon: React.FC<IProps> = ({ icon, className = '' }) => {
	return <span className={`inline-block ${className}`}>{icon}</span>;
};
